import { render } from "./AddColis.vue?vue&type=template&id=672f563e&ts=true"
import script from "./AddColis.vue?vue&type=script&lang=ts"
export * from "./AddColis.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__